import { render, staticRenderFns } from "./IngredientsTableMobile.vue?vue&type=template&id=08321f00&scoped=true&lang=pug&"
import script from "./IngredientsTableMobile.vue?vue&type=script&lang=js&"
export * from "./IngredientsTableMobile.vue?vue&type=script&lang=js&"
import style0 from "./IngredientsTableMobile.vue?vue&type=style&index=0&id=08321f00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08321f00",
  null
  
)

export default component.exports